import {
  LOAD_PROTECTED_PAGE_REQUEST,
  LOAD_PROTECTED_PAGE_RESPONSE
} from '../constants/action-types'

const protectedPageReducer = (
  state = {
    loadProtectedPageError: false,
    loadProtectedPageInProgress: true,
    loadProtectedPageStatus: -1
  },
  action
) => {
  switch (action.type) {
    case LOAD_PROTECTED_PAGE_REQUEST:
      return Object.assign({}, state, {
        loadProtectedPageInProgress: true
      })
    case LOAD_PROTECTED_PAGE_RESPONSE:
      return Object.assign({}, state, {
        loadProtectedPageError: action.error,
        loadProtectedPageStatus: action.payload.status,
        loadProtectedPageInProgress: false
      })
    default:
      return state
  }
}

export default protectedPageReducer



// WEBPACK FOOTER //
// ./src/reducers/protected-page-reducer.js